<template>
    <div>
        <AuditsTable/>
    </div>
</template>

<script>
import { facilityAdminMethods } from '@/state/helpers'
import AuditsTable from './auditsTable.vue'
export default {
    data:() => ({}),
    components:{
        AuditsTable
    },
    computed:{},
    methods:{ ...facilityAdminMethods},
    mounted(){},
    beforeDestroy(){
        this.clearAuditData();
    }
}
</script>

<style>

</style>